import { PageableQueryParams } from 'src/entities/basic-types/Pageable';
import { action } from 'src/store/actions';

/* Landingpages */
export const FETCH_ALL_LANDINGPAGES = 'FETCH_ALL_LANDINGPAGES';
export const REQUEST_ALL_LANDINGPAGES = 'REQUEST_ALL_LANDINGPAGES';
export const SUCCESS_ALL_LANDINGPAGES = 'SUCCESS_ALL_LANDINGPAGES';
export const FAILURE_ALL_LANDINGPAGES = 'FAILURE_ALL_LANDINGPAGES';

export const fetchAllLandingpages = (pageable?: PageableQueryParams) => action(FETCH_ALL_LANDINGPAGES, { pageable });
export const requestAllLandingpages = () => action(REQUEST_ALL_LANDINGPAGES);
export const requestAllLandingpagesSuccess = (response: any) => action(SUCCESS_ALL_LANDINGPAGES, { response });
export const requestAllLandingpagesFailure = (error: any) => action(FAILURE_ALL_LANDINGPAGES, { error });
